import { render } from "./Forums.vue?vue&type=template&id=e51f677e&scoped=true"
import script from "./Forums.vue?vue&type=script&lang=js"
export * from "./Forums.vue?vue&type=script&lang=js"

import "./Forums.vue?vue&type=style&index=0&id=e51f677e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51f677e"]])

export default __exports__